import { useEffect, useState } from 'react';
import { Card, Row, Col, Typography, Tooltip } from 'antd';
import LeaveConfig from "@/config/leave";
import {
  getStartTimeToday,
  getEndTimeAfterXDays,
  convertToTimestamp,
  convertTimestampToFormat,
  dateFormatSlash,
} from "@lib/dateTime";
import { getLangList } from "@/lib/i18n";
import { LeaveType } from "./types";

const { getLeaveInfo } = LeaveConfig;

function StudentSchedule() {
  const [leaveArray, setLeaveArray] = useState<LeaveType[]>([]);
  const leaveT: any = getLangList("leave");
  const homeT: any = getLangList("home");
  const leaveName: any = {
    sick: leaveT.SICK,
    personal: leaveT.PERSONAL,
    other: leaveT.OTHER,
  };

  useEffect(() => {
    getLeaveInfoFunction();
  }, []);

  function getLeaveInfoFunction() {
    const params = {
      startTime: convertToTimestamp(getStartTimeToday()),
      endTime: convertToTimestamp(getEndTimeAfterXDays(1)),
    }

    getLeaveInfo(params).then((res: any) => {
      const { value = [] } = res ?? {};
      setLeaveArray(value);
    });
  }

  return (
    <Card
      title={homeT.STUDENT_SCHEDULE}
      size="small"
      className="schedule-card"
    >
      <Row className="home-student-list-container" gutter={[12, 12]}>
        {leaveArray.map((item: LeaveType, index: number) => {
          const { className, nameEn, leaveType, startTime, endTime, teacherNameEn } = item;
          const formatStartTime = convertTimestampToFormat(startTime, dateFormatSlash);
          const formatEndTime = convertTimestampToFormat(endTime, dateFormatSlash);

          return (
            <Col span={24} key={index}>
              <Row gutter={[24, 24]} wrap={false}>
                <Col className="home-student-list-class" flex={"0 1 220px"}>
                  <Tooltip title={className}>
                    <Typography.Text ellipsis>{className}</Typography.Text>
                  </Tooltip>
                </Col>

                <Col className="home-student-list-name" flex={"0 1 100px"}>
                  <Tooltip title={nameEn}>
                    <Typography.Text ellipsis>{nameEn}</Typography.Text>
                  </Tooltip>
                </Col>

                <Col className={`home-student-list-leave ${leaveType}`} flex={"0 1 52px"}>
                  <Tooltip title={leaveName[leaveType]}>
                    <Typography.Text ellipsis>{leaveName[leaveType]}</Typography.Text>
                  </Tooltip>
                </Col>

                <Col className="home-student-list-date" flex={"0 1 224px"}>
                  <Tooltip title={`${formatStartTime} ~ ${formatEndTime}`}>
                    <Typography.Text ellipsis>{`${formatStartTime} ~ ${formatEndTime}`}</Typography.Text>
                  </Tooltip>
                </Col>

                <Col className="home-student-list-teacher" flex={"1 1 100px"}>
                  <Tooltip title={teacherNameEn}>
                    <Typography.Text ellipsis>{teacherNameEn}</Typography.Text>
                  </Tooltip>
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
}

export default StudentSchedule;